import React, { useRef, useState } from "react";

import Button from "./Button";

export default function FileInput({ onChange, buttonProps, buttonText }) {
  const fileInput = useRef(null);
  const [file, setFile] = useState(null);

  return (
    <div>
      <div style={{ height: 1, width: 1, overflow: "hidden" }}>
        <input
          ref={fileInput}
          type="file"
          name="file"
          onChange={(event) => {
            setFile(event.target.files[0]);
            onChange(event);
          }}
        />
      </div>
      <Button
        {...buttonProps}
        color={"primary"}
        className="mb-2"
        onClick={() => fileInput.current.click()}
      >
        {file ? "Ready to Upload" : buttonText || "Select file"}
      </Button>
    </div>
  );
}
